import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import { IconToastSuccess } from '../../../../../../assets/toast-icons/icon-toast-success';
import { IconToastWarning2 } from '../../../../../../assets/toast-icons/icon-toast-warning-2';

type FloodControlProps = {
  value: boolean | null;
};

export const FloodControl: React.FC<FloodControlProps> = ({ value }) => {
  const { t } = useTranslation('channel-details');

  const renderFloodContent = () => {
    if (value === true)
      return (
        <>
          <IconToastWarning2 colorError size={16} />
          <span className="sensor-control-box__error-text">{t('exalus.floodDetected.heading')}</span>
        </>
      );

    if (value === false) return <IconToastSuccess />;

    return <span className="sensor-control-box__status">{t('exalus.sensor.noData')}</span>;
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" padding="0 10px">
      {renderFloodContent()}
    </Stack>
  );
};
